angular.module('bmsApp.geocode', [
	'bmsApp.crm',
	'bmsApp.employee',
	'ui.router',
	'uiGmapgoogle-maps'
])
	.config([
		'$stateProvider', 'uiGmapGoogleMapApiProvider', function config($stateProvider,
																		uiGmapGoogleMapApiProvider) {

			$stateProvider

				.state('main.geocode', {
					url: '^/geocode/missing-records',
					views: {
						'main@main': {
							templateUrl: 'ng/global/geocode/templates/GeocodeMap.html',
							controller: 'GeocodeMapCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Geocode Missing Records'}
				})

				.state('main.crm.customer.index.view.geocode', {
					url: '^/crm/customer/geocode/{customerId:int}',
					views: {
						'main@main': {
							templateUrl: 'ng/global/geocode/templates/GeocodeMap.html',
							controller: 'GeocodeMapCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Geocode Site Records'}
				})

				.state('main.employee.index.view.geocode', {
					url: '^/employee/geocode/{employeeId:int}',
					views: {
						'main@main': {
							templateUrl: 'ng/global/geocode/templates/GeocodeMap.html',
							controller: 'GeocodeMapCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Geocode Record'}
				})

				.state('main.settings.businessDetails.geocode', {
					url: '/geocode',
					views: {
						'main@main': {
							templateUrl: 'ng/global/geocode/templates/GeocodeMap.html',
							controller: 'GeocodeMapCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Geocode Record'}
				})

			;

		}]);
